// test806
(806 && 0);
